import { Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import { useFormik } from "formik";
import useModalLoading from "libs/hooks/useModalLoading";
import usePrevious from "libs/hooks/usePrevious";
import {
  getErrorMessage,
  isError,
  mapFieldValidate,
  mapFieldValidateWithFieldName
} from "libs/utils/form";
import { formatPrice } from "libs/utils/format";
import { get } from "lodash";
import mrz from "mrz";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import {
  addPopupSmartForm,
  addSmartFormSlice,
  getCoditionType,
  getCoditionVisa,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCoditionType,
  selectCoditionVisa,
  selectCurrentSmartServiceId,
  selectSmartFormFieldConfig,
  setConditionType
} from "redux/modules/visaForm";
import * as yup from "yup";

const x = mrz.parse;

const ConditionType = {
  Company: "Company",
  Government: "Government",
  START_UP: "Start up",
  VENTURE_CAPITAL: "Venture Capital",
  INVESTMENTS: "INVESTMENTS",
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
    width: 820,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    height: 34,
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
}));

export default function RequestTalentForma({
  onCancel = () => { },
  onSubmit = () => { },
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const modalLoading = useModalLoading();

  const personalDetailState = useSelector(selectPersonalDetail);
  const smartVisaServiceId = useSelector(selectCurrentSmartServiceId);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const fieldConfigState = useSelector(selectSmartFormFieldConfig);
  const coditionType = useSelector(selectCoditionType);
  const {
    isLoading,
    isSuccess,
    data: coditionVisa,
  } = useSelector(selectCoditionVisa);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      modalLoading.showLoading();
    } else {
      if (addSmartFormState.isSuccess) {
        modalLoading.hideLoading();
        onSubmit();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      } else if (addSmartFormState.isFailure) {
        modalLoading.hideLoading();
        alert(JSON.stringify(addSmartFormState.error));
      }
    }
  }, [
    addSmartFormState.error,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    modalLoading,
    onSubmit,
  ]);

  useEffect(() => {
    if (smartVisaServiceId) {
      dispatch(
        getCoditionVisa({
          smartVisaServiceId,
          ConditionType: ConditionType.INVESTMENTS,
        })
      );
      dispatch(getCoditionType({ smartserviceId: smartVisaServiceId }));
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartVisaServiceId }));
    }
  }, [dispatch, smartVisaServiceId]);

  const BaseInvestmentsFieldListConfig = [
    {
      name: "Non",
      companyName: "NonCompanyName",
      label: "Tech-based company (non-startup)",
    },
    {
      name: "Ven",
      companyName: "VenCompanyName",
      label: "Venture Capital company",
    },
    {
      name: "Tec",
      companyName: "TecCompanyName",
      label: "Tech-based startup company",
    },
    {
      name: "Inc",
      companyName: "IncCompanyName",
      label: "Incubation or accelerator program",
    },
    {
      name: "Oth",
      companyName: "OthCompanyName",
      label: "Other investment(s) (Please specify)",
    },
  ];

  const defaultType = get(coditionVisa, "defaultType", []);
  const extraField = get(coditionVisa, "extraType", []);

  const getMinValue = (fieldName) =>
    defaultType.find((v) => v.conditionField === fieldName)
      ?.conditionValueMax ?? 0;

  const minErrorMessage = (fieldName) =>
    `Total amount should more than ${formatPrice(
      getMinValue(fieldName) || "0"
    )}`;

  const callAPISubmit = async (
    values,
    { isNonValid, isVenValid, isTecValid, isIncValid, isOthValid }
  ) => {
    const defaultType = get(fieldConfigState, "data.defaultType", []);
    const getFieldListConfig = defaultType.filter((field) =>
      [
        // "ConditionType",
        "Companies",
        // ...BaseInvestmentsFieldListConfig.map((v) => v.name),
      ].includes(field.smartName)
    );

    const getValue = (field) => {
      if (field.smartName === "ConditionType") {
        dispatch(setConditionType(values[field.smartName]));
        return `${values[field.smartName]}` || null;
      }

      if (field.smartName === "Companies") {
        let companyValues = [];

        const mapCompaniesValue = (CompanyName, ValueofShares) => ({
          companiesId: null,
          CompanyName: values[CompanyName] || "",
          ValueofShares: values[ValueofShares] || 0,
          AmountOfConvertibledebt: 0,
          Status: true,
        });

        if (isNonValid) {
          companyValues.push(mapCompaniesValue("NonCompanyName", "Non"));
        }
        if (isVenValid) {
          companyValues.push(mapCompaniesValue("VenCompanyName", "Ven"));
        }
        if (isTecValid) {
          companyValues.push(mapCompaniesValue("TecCompanyName", "Tec"));
        }
        if (isIncValid) {
          companyValues.push(mapCompaniesValue("IncCompanyName", "Inc"));
        }
        if (isOthValid) {
          companyValues.push(mapCompaniesValue("OthCompanyName", "Oth"));
        }

        return companyValues.length ? companyValues : null;
      }

      return `${values[field.smartName]}` || null;
    };

    const prepareData = {
      draftId: null,
      smartserviceId: smartVisaServiceId,
      personalId: get(personalDetailState, "personalID", ""),
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: null,
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    const response = await dispatch(
      addPopupSmartForm({
        data: prepareData,
        images: [],
      })
    );
    await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
    // onSubmit(values);
  };

  const validationSchema = yup.object().shape({
    ...defaultType.reduce(mapFieldValidateWithFieldName("Total amount"), {}),
    ...extraField.reduce(mapFieldValidate, {}),

    NonCompanyName: yup.string().when("Non", {
      is: (Non) => !!Non,
      then: yup.string().required("Company name is required"),
      otherwise: yup.string(),
    }),
    VenCompanyName: yup.string().when("Ven", {
      is: (Ven) => !!Ven,
      then: yup.string().required("Company name is required"),
      otherwise: yup.string(),
    }),
    TecCompanyName: yup.string().when("Tec", {
      is: (Tec) => !!Tec,
      then: yup.string().required("Company name is required"),
      otherwise: yup.string(),
    }),
    IncCompanyName: yup.string().when("Inc", {
      is: (Inc) => !!Inc,
      then: yup.string().required("Company name is required"),
      otherwise: yup.string(),
    }),
    OthCompanyName: yup.string().when("Oth", {
      is: (Oth) => !!Oth,
      then: yup.string().required("Company name is required"),
      otherwise: yup.string(),
    }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ConditionType: ConditionType.Investments,
      ...extraField.reduce((p, c) => ({ ...p, [c.conditionField]: "" }), {}),
      Non: "",
      Ven: "",
      Tec: "",
      Inc: "",
      Oth: "",
      NonCompanyName: "",
      VenCompanyName: "",
      TecCompanyName: "",
      IncCompanyName: "",
      OthCompanyName: "",
    },
    validationSchema,
    onSubmit: (values) => {
      callAPISubmit(values);
    },
  });

  const isLoadingChange = usePrevious(isLoading) !== isLoading;
  // useEffect(() => {
  //   const validateInvestments = () => formik.validateField("Investments");
  //   if (isLoadingChange && !isLoading && isSuccess) {
  //     validateInvestments();
  //   }
  // }, [formik, isLoadingChange, isLoading, isSuccess]);

  const InvestmentsFieldListConfig = BaseInvestmentsFieldListConfig.map(
    (c) => ({
      ...c,
      ...(defaultType.find((dt) => dt.conditionField === c.name) || {}),
    })
  );

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        QUALIFICATION ENDORSEMENT FOR SMART VISA “I”
      </Typography>
      <Typography variant="h4" color="secondary">
        Qualifications and Criteria
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1} style={{ marginTop: 30 }}>
          {InvestmentsFieldListConfig.map((field, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" className={classes.label}>
                  {field.label}
                </Typography>
                <TextField
                  className={classes.formControl}
                  variant="outlined"
                  placeholder="Company name"
                  name={field?.companyName}
                  // type={
                  //   ["int", "double"].includes(field?.conditionValue)
                  //     ? "number"
                  //     : "text"
                  // }
                  value={formik.values[field?.companyName]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(field?.companyName, formik)}
                  helperText={getErrorMessage(field?.companyName, formik)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" className={classes.label}>
                  Total amount (Baht)
                </Typography>
                <TextField
                  className={classes.formControl}
                  variant="outlined"
                  name={field?.conditionField}
                  type={
                    ["int", "double"].includes(field?.conditionValue)
                      ? "number"
                      : "text"
                  }
                  value={formik.values[field?.conditionField]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(field?.conditionField, formik)}
                  helperText={getErrorMessage(field?.conditionField, formik)}
                />
              </Grid>
            </React.Fragment>
          ))}

          {[...extraField].map((field) => (
            <Grid item xs={12} md={6} key={field.conditionField}>
              <Typography variant="h6" className={classes.label}>
                {field.conditionField}
              </Typography>
              <TextField
                className={classes.formControl}
                variant="outlined"
                placeholder={field.conditionField}
                name={field.conditionField}
                type={
                  ["int", "double"].includes(field.conditionValue)
                    ? "number"
                    : "text"
                }
                value={formik.values[field.conditionField]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(field.conditionField, formik)}
                helperText={getErrorMessage(field.conditionField, formik)}
              />
            </Grid>
          ))}

          <Grid item xs={0} md={8}></Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="outlined"
              onClick={onCancel}
            >
              Cancel
            </ColorButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="contained"
              color="secondary"
              disabled={false}
              type="button"
              onClick={() => {
                const getIsValidField = (fieldName, companyNameField) => {
                  const isAmountFieldValid =
                    formik.values[fieldName] && !formik.errors[fieldName];
                  const isCompanyFieldValid =
                    formik.values[companyNameField] &&
                    !formik.errors[companyNameField];

                  if (isAmountFieldValid && isCompanyFieldValid) return true;

                  if (isAmountFieldValid && !isCompanyFieldValid) {
                    formik.setFieldTouched(companyNameField, true, true);
                    formik.validateField(companyNameField);
                  }

                  return false;
                };

                const isNonValid = getIsValidField("Non", "NonCompanyName");
                const isVenValid = getIsValidField("Ven", "VenCompanyName");
                const isTecValid = getIsValidField("Tec", "TecCompanyName");
                const isIncValid = getIsValidField("Inc", "IncCompanyName");
                const isOthValid = getIsValidField("Oth", "OthCompanyName");

                if (
                  isNonValid ||
                  isVenValid ||
                  isTecValid ||
                  isIncValid ||
                  isOthValid
                ) {
                  callAPISubmit(formik.values, {
                    isNonValid,
                    isVenValid,
                    isTecValid,
                    isIncValid,
                    isOthValid,
                  });
                }
              }}
            >
              Next
            </ColorButton>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
